import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'ingsvNumberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: any) {
    if (value == null) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
